import { compose, withHandlers, withProps } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import scrolledTo from 'components/common/hoc/scrolledTo'
import { getCompletedSteps, checkIsAllStepsCompeted } from './selectors'
import { sendServicesAndDateTime } from 'components/Appointment/actions'
import BOTMakeAppointmentHeaderComponent from './BOTMakeAppointmentHeader'

const APPOINTMENT_HEADER_ID = 'appointment-header'

const mapDispatchToProps = state => {
  const completedSteps = getCompletedSteps(state)

  return {
    completedSteps,
    allStepsCompleted: checkIsAllStepsCompeted(completedSteps)
  }
}

export default compose(
  withType({ type: 'BOTMakeAppointmentHeader', placeholders: ['steps']}),
  connect(mapDispatchToProps, { sendServicesAndDateTime }),
  withProps({
    id: APPOINTMENT_HEADER_ID,
    isFromOnlineAppointment: true
  }),
  withHandlers({
    onClickHandler: ({ sendServicesAndDateTime, isFromOnlineAppointment }) => () =>
      sendServicesAndDateTime(isFromOnlineAppointment)
  }),
  scrolledTo
)(BOTMakeAppointmentHeaderComponent)
